// AUTO-GENERATED SQL Builder (V40 Final) for CardRsvp
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class CardRsvpSql {
  private ast = new SqlAst('CardRsvp', 'cardRsvp');
  public readonly main: any = {};

  public guid: SqlField;
  public weddingCardId: SqlField;
  public guestName: SqlField;
  public isAttending: SqlField;
  public pax: SqlField;
  public respondedDate: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public weddingCard: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('cardRsvp', 'guid', '', 'id', 'cardRsvp_guid');
    this.weddingCardId = new SqlField('cardRsvp', 'weddingCardId', 'weddingCard', 'id', 'cardRsvp_weddingCard');
    this.guestName = new SqlField('cardRsvp', 'guestName', '', 'id', 'cardRsvp_guestName');
    this.isAttending = new SqlField('cardRsvp', 'isAttending', '', 'id', 'cardRsvp_isAttending');
    this.pax = new SqlField('cardRsvp', 'pax', '', 'id', 'cardRsvp_pax');
    this.respondedDate = new SqlField('cardRsvp', 'respondedDate', '', 'id', 'cardRsvp_respondedDate');
    this.createdByUser = createNavHybrid('cardRsvp', 'cardRsvp_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('cardRsvp', 'cardRsvp_updatedByUser', 'User');
    this.weddingCard = createNavHybrid('cardRsvp', 'cardRsvp_weddingCard', 'WeddingCard');
    this.id = new SqlField('cardRsvp', 'id', '', 'id', 'cardRsvp_id');
    this.isDeleted = new SqlField('cardRsvp', 'isDeleted', '', 'id', 'cardRsvp_isDeleted');
    this.createdBy = new SqlField('cardRsvp', 'createdBy', '', 'id', 'cardRsvp_createdBy');
    this.createdDate = new SqlField('cardRsvp', 'createdDate', '', 'id', 'cardRsvp_createdDate');
    this.updatedBy = new SqlField('cardRsvp', 'updatedBy', '', 'id', 'cardRsvp_updatedBy');
    this.updatedDate = new SqlField('cardRsvp', 'updatedDate', '', 'id', 'cardRsvp_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:CardRsvpSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:CardRsvpSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:CardRsvpSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:CardRsvpSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:CardRsvpSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:CardRsvpSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:CardRsvpSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:CardRsvpSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:CardRsvpSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:CardRsvpSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
